/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  UnmarkRiskResultsFalsePositiveRequestBody,
  UnmarkRiskResultsFalsePositiveRequestBody$Outbound,
  UnmarkRiskResultsFalsePositiveRequestBody$outboundSchema,
} from "../components/unmarkriskresultsfalsepositiverequestbody.js";

export type UnmarkRiskResultsFalsePositiveSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type UnmarkRiskResultsFalsePositiveSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type UnmarkRiskResultsFalsePositiveSecurity = {
  option1?: UnmarkRiskResultsFalsePositiveSecurityOption1 | undefined;
  option2?: UnmarkRiskResultsFalsePositiveSecurityOption2 | undefined;
};

export type UnmarkRiskResultsFalsePositiveRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  unmarkRiskResultsFalsePositiveRequestBody:
    UnmarkRiskResultsFalsePositiveRequestBody;
};

/** @internal */
export type UnmarkRiskResultsFalsePositiveSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const UnmarkRiskResultsFalsePositiveSecurityOption1$outboundSchema:
  z.ZodMiniType<
    UnmarkRiskResultsFalsePositiveSecurityOption1$Outbound,
    UnmarkRiskResultsFalsePositiveSecurityOption1
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function unmarkRiskResultsFalsePositiveSecurityOption1ToJSON(
  unmarkRiskResultsFalsePositiveSecurityOption1:
    UnmarkRiskResultsFalsePositiveSecurityOption1,
): string {
  return JSON.stringify(
    UnmarkRiskResultsFalsePositiveSecurityOption1$outboundSchema.parse(
      unmarkRiskResultsFalsePositiveSecurityOption1,
    ),
  );
}

/** @internal */
export type UnmarkRiskResultsFalsePositiveSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const UnmarkRiskResultsFalsePositiveSecurityOption2$outboundSchema:
  z.ZodMiniType<
    UnmarkRiskResultsFalsePositiveSecurityOption2$Outbound,
    UnmarkRiskResultsFalsePositiveSecurityOption2
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function unmarkRiskResultsFalsePositiveSecurityOption2ToJSON(
  unmarkRiskResultsFalsePositiveSecurityOption2:
    UnmarkRiskResultsFalsePositiveSecurityOption2,
): string {
  return JSON.stringify(
    UnmarkRiskResultsFalsePositiveSecurityOption2$outboundSchema.parse(
      unmarkRiskResultsFalsePositiveSecurityOption2,
    ),
  );
}

/** @internal */
export type UnmarkRiskResultsFalsePositiveSecurity$Outbound = {
  Option1?: UnmarkRiskResultsFalsePositiveSecurityOption1$Outbound | undefined;
  Option2?: UnmarkRiskResultsFalsePositiveSecurityOption2$Outbound | undefined;
};

/** @internal */
export const UnmarkRiskResultsFalsePositiveSecurity$outboundSchema:
  z.ZodMiniType<
    UnmarkRiskResultsFalsePositiveSecurity$Outbound,
    UnmarkRiskResultsFalsePositiveSecurity
  > = z.pipe(
    z.object({
      option1: z.optional(z.lazy(() =>
        UnmarkRiskResultsFalsePositiveSecurityOption1$outboundSchema
      )),
      option2: z.optional(z.lazy(() =>
        UnmarkRiskResultsFalsePositiveSecurityOption2$outboundSchema
      )),
    }),
    z.transform((v) => {
      return remap$(v, {
        option1: "Option1",
        option2: "Option2",
      });
    }),
  );

export function unmarkRiskResultsFalsePositiveSecurityToJSON(
  unmarkRiskResultsFalsePositiveSecurity:
    UnmarkRiskResultsFalsePositiveSecurity,
): string {
  return JSON.stringify(
    UnmarkRiskResultsFalsePositiveSecurity$outboundSchema.parse(
      unmarkRiskResultsFalsePositiveSecurity,
    ),
  );
}

/** @internal */
export type UnmarkRiskResultsFalsePositiveRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  UnmarkRiskResultsFalsePositiveRequestBody:
    UnmarkRiskResultsFalsePositiveRequestBody$Outbound;
};

/** @internal */
export const UnmarkRiskResultsFalsePositiveRequest$outboundSchema:
  z.ZodMiniType<
    UnmarkRiskResultsFalsePositiveRequest$Outbound,
    UnmarkRiskResultsFalsePositiveRequest
  > = z.pipe(
    z.object({
      gramKey: z.optional(z.string()),
      gramSession: z.optional(z.string()),
      gramProject: z.optional(z.string()),
      unmarkRiskResultsFalsePositiveRequestBody:
        UnmarkRiskResultsFalsePositiveRequestBody$outboundSchema,
    }),
    z.transform((v) => {
      return remap$(v, {
        gramKey: "Gram-Key",
        gramSession: "Gram-Session",
        gramProject: "Gram-Project",
        unmarkRiskResultsFalsePositiveRequestBody:
          "UnmarkRiskResultsFalsePositiveRequestBody",
      });
    }),
  );

export function unmarkRiskResultsFalsePositiveRequestToJSON(
  unmarkRiskResultsFalsePositiveRequest: UnmarkRiskResultsFalsePositiveRequest,
): string {
  return JSON.stringify(
    UnmarkRiskResultsFalsePositiveRequest$outboundSchema.parse(
      unmarkRiskResultsFalsePositiveRequest,
    ),
  );
}
